import { FilterType } from 'lemunzo-api';

/**
 * Maps PrimeNG filter match modes to generated API {@link FilterType} enum values.
 */
export const FilterMatchModeToFilterType: Map<string, FilterType> = new Map([
    ['startsWith', FilterType.StartsWith],
    ['contains', FilterType.Contains],
    ['notContains', FilterType.NotContains],
    ['endsWith', FilterType.EndsWith],
    ['equals', FilterType.Equals],
    ['notEquals', FilterType.NotEquals],
    ['lt', FilterType.LessThan],
    ['lte', FilterType.LessThanOrEqual],
    ['gt', FilterType.GreaterThan],
    ['gte', FilterType.GreaterThanOrEqual],
    ['is', FilterType.Equals],
    ['isNot', FilterType.NotEquals],
    ['before', FilterType.LessThan],
    ['after', FilterType.GreaterThan],
    ['dateIs', FilterType.Equals],
    ['dateIsNot', FilterType.NotEquals],
    ['dateBefore', FilterType.LessThan],
    ['dateAfter', FilterType.GreaterThan],
]);
